import {css} from '@emotion/react';
import React from 'react';

import type {BaseMobileMenuDrawerProps} from '../../components/BaseMobileMenuDrawer';

import ChevronRight from '../../assets/icons/ChevronRight';
import BaseMobileMenuDrawer from '../../components/BaseMobileMenuDrawer';
import ExtendedNavLink from '../../components/ExtendedNavLink';
import {useAppTheme, useColor, useTypography} from '../../styles';
import {navItems} from './useNavLinks';

type MobileMenuDrawerProps = Omit<BaseMobileMenuDrawerProps, 'nav'>;

const MobileMenuDrawer = (props: MobileMenuDrawerProps) => {
  const {onCloseClick} = props;
  const {spacings} = useAppTheme();
  const {palette} = useColor();
  const {link} = useTypography();

  const navCss = css({
    display: 'flex',
    flexDirection: 'column',
  });

  const navItemCss = css({
    borderBottom: `${spacings.px2} solid ${palette.border.light.defaultColor}`,
    paddingTop: spacings.px16,
    paddingBottom: spacings.px16,
  });

  const chevronStyle = css({fontSize: spacings.px24});

  const renderNavItems = () => {
    const renderItem = (text: string) => {
      const textContainer = css([
        {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      ]);

      return (
        <div css={textContainer}>
          <span>{text}</span>
          <ChevronRight css={chevronStyle} />
        </div>
      );
    };

    return navItems.map(({text, url}, index) => {
      return (
        <li
          css={navItemCss}
          key={index}
        >
          <ExtendedNavLink
            css={link}
            onClick={onCloseClick}
            to={url}
          >
            {renderItem(text)}
          </ExtendedNavLink>
        </li>
      );
    });
  };

  const nav = (
    <nav>
      <ul css={navCss}>{renderNavItems()}</ul>
    </nav>
  );

  return (
    <BaseMobileMenuDrawer
      nav={nav}
      onCloseClick={onCloseClick}
    />
  );
};

export default MobileMenuDrawer;
